angular.module('wbControllers').controller('FooterController',

  ['$scope', 'locale', function ($scope, locale) {
    $scope.language = locale.getCurrentLanguage();
    $scope.languageToggle = function() {
        if (locale.getCurrentLanguage() === 'french') {
          locale.setLanguage('english', false);
        } else {
          locale.setLanguage('french', false);
        }
        $scope.language = locale.getCurrentLanguage();
      }
    },
  ]);
